import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { Dashicon } from '@wordpress/components';
import { iconNameToSVG } from '../inspector-icon-selector';

const InspectorDashCustomIcon = ( { iconName, icon } ) => {
	// const { label, options, value, onChange, iconButton } = props;
	const customIcon = iconNameToSVG( iconName ?? icon );

	return customIcon ? (
		<span style={ { width: '20px', height: '20px' } }>{ customIcon }</span>
	) : (
		<Dashicon icon={ iconName ?? icon } />
	);
	// return (<Dashicon icon={iconName??icon} />);
};

export default InspectorDashCustomIcon;
